import { useLocalization } from "@tm/localization"
import { useActions } from "@tm/morpheus"
import { setValue } from "@tm/utils"
import { useSelector } from "react-redux"
import { useCallback, useMemo } from "react"
import GeneralCustomerForm from "@bundles/damage-calculation-dat/components/_shared/GeneralCustomerFields"
import { createSelector } from "reselect"
import { MainActions } from "../../main/business"
import { MainState } from "../../main"
import { getEurotaxCustomerSchema } from "../business/helpers/getEurotaxSchemas"

export const customerFieldsSelector = createSelector(
    (s: MainState) => s.summary.customerFields,
    (fields) => {
        const { firstName, lastName } = fields
        return { firstName, lastName }
    }
)

export default function CustomerFields() {
    const { translateText } = useLocalization()
    const customerFields = useSelector(customerFieldsSelector)
    const actions = useActions(MainActions, "updateCustomerFields", "setValidateFields")
    const eurotaxSchema = useMemo(() => getEurotaxCustomerSchema(translateText), [translateText])

    const handleChange = useCallback(
        (path: string, value: string) => {
            setValue(customerFields, [path], value)
            actions.updateCustomerFields(customerFields)
        },
        [customerFields, actions]
    )

    const handleFormValid = useCallback(
        (isValid: boolean) => {
            actions.setValidateFields("customerValid", isValid)
        },
        [actions]
    )

    return <GeneralCustomerForm onFormValid={handleFormValid} schema={eurotaxSchema} onUpdateFieldValue={handleChange} fields={customerFields} />
}
